import { evaluateCondition } from './conditions';
import { applyAction }       from './actions';
import { filterOptions }     from './optionFilter';
import { createDerivedState } from '../model/fieldConfig';

export function evaluateFormState(values, fieldConfigs) {
  if (!Array.isArray(fieldConfigs) || fieldConfigs.length === 0) return {};
  const safeValues = values ?? {};

  const state = {};
  fieldConfigs.forEach(field => {
    state[field.fieldKey] = createDerivedState(field);
  });

  fieldConfigs.forEach(field => {
    const selfValue = safeValues[field.fieldKey];

    if (Array.isArray(field.effects) && field.effects.length > 0) {
      field.effects.forEach(effect => {
        if (!evaluateCondition(effect.when, selfValue, safeValues)) return;

        effect.actions.forEach(action => {
          const targetKeys = resolveTargetKeys(action.target, fieldConfigs, field.fieldKey);
          const resolvedAction = resolveDynamicActionValue(action, fieldConfigs, safeValues, field.fieldKey);
          targetKeys.forEach(targetKey => {
            applyAction(state, targetKey, resolvedAction);
          });
        });
      });
    }

    const allFilters = [];
    if (field.optionFilter) allFilters.push(field.optionFilter);
    if (Array.isArray(field.optionFilters)) allFilters.push(...field.optionFilters);

    allFilters.forEach(filter => {
      const targetKeys = resolveTargetKeys(filter.target, fieldConfigs, field.fieldKey);
      targetKeys.forEach(targetKey => {
        if (!state[targetKey]) return;
        const targetConfig = fieldConfigs.find(f => f.fieldKey === targetKey);
        if (targetConfig) {
          state[targetKey].options = filterOptions(
            state[targetKey].options ?? targetConfig.options,
            selfValue,
            filter,
            safeValues
          );
        }
      });
    });
  });

  return state;
}

function resolveDynamicActionValue(action, fieldConfigs, values, ownerFieldKey) {
  if (!Array.isArray(action.sources)) return action;

  const total = action.sources.reduce((sum, pattern) => {
    const keys = resolveTargetKeys(pattern, fieldConfigs, ownerFieldKey);
    return sum + keys.reduce((acc, key) => acc + parseDecimal(values[key]), 0);
  }, 0);

  return { ...action, value: total.toFixed(action.decimalPlaces ?? 2) };
}

function parseDecimal(val) {
  const cleaned = String(val ?? '').replace(/,/g, '').trim();
  const num = parseFloat(cleaned);
  return Number.isNaN(num) ? 0 : num;
}

function resolveTargetKeys(target, fieldConfigs, ownerFieldKey = null) {
  if (!target) return [];

  if (target === 'self') {
    return ownerFieldKey ? [ownerFieldKey] : [];
  }

  if (target.endsWith('*')) {
    const prefix = target.slice(0, -1);
    return fieldConfigs
      .filter(f => f.fieldKey.startsWith(prefix))
      .map(f => f.fieldKey);
  }
  return fieldConfigs.some(f => f.fieldKey === target) ? [target] : [];
}
